const translations = {
  "en": {
    "Binding failed: %{var0}": "Binding failed: %{var0}",
    "Binding successful": "Binding successful",
    "My Money shows your bank and card accounts. Link a bank or card next.": "My Money shows your bank and card accounts. Link a bank or card next.",
    "Portfolio shows your investment accounts only": "Portfolio shows your investment accounts only"
  },
  "zh-tw": {
    "Binding failed: %{var0}": "綁定失敗：%{var0}",
    "Binding successful": "綁定成功",
    "My Money shows your bank and card accounts. Link a bank or card next.": "My Money 顯示你的銀行與卡片帳戶。下一步請連結銀行或卡片。",
    "Portfolio shows your investment accounts only": "投資組合僅顯示你的投資帳戶。"
  }
};

export default translations;
